export default "__VITE_ASSET__9b554806__"